import { Button } from '@progress/kendo-react-buttons';
import { ChevronLeftOutline, ChevronRightOutline, DoubleChevronLeftOutline, DoubleChevronRightOutline } from '../../icons/icons';
import DrawingObjectEditPoint from './DrawingObjectEditPoint';
import React from 'react';

interface DrawingObjectPolygonPointsProps {
    points: PolygonPoints[];
    disabled: boolean;
    onPointDelete: (index: number) => void;
    onPointChange: (index: number, newPosition: number[]) => void;
}

export interface PolygonPoints {
    id: number;
    lngLat: number[];
}

const SIZE = 15;

const DrawingObjectPolygonPoints = (props: DrawingObjectPolygonPointsProps) => {
    const [page, setPage] = React.useState(0);

    const maxPage = Math.ceil((props.points.length - 1) / SIZE);
    const isLastPage = page + 1 === maxPage;
    const firstPage = page === 0;

    React.useEffect(() => {
        if (page * SIZE + 1 > props.points.length - 1) {
            setPage(Math.max(0, page - 1));
        }
    }, [page, props.points.length]);

    return (
        <div>
            <div className="pt-2 pb-1 secondary-text">Polygon points ({props.points.length - 1})</div>
            {props.points.length - 1 > SIZE && (
                <div className="d-flex gap-1 pb-1">
                    <Button
                        svgIcon={DoubleChevronLeftOutline}
                        fillMode={'outline'}
                        className="button-small"
                        disabled={firstPage}
                        onClick={() => setPage(0)}
                    />
                    <Button
                        svgIcon={ChevronLeftOutline}
                        fillMode={'outline'}
                        className="button-small"
                        disabled={firstPage}
                        onClick={() => setPage(page - 1)}
                    />
                    <div className="flex-grow-1 text-center secondary-text">
                        page {page + 1} of {maxPage}
                    </div>
                    <Button
                        svgIcon={ChevronRightOutline}
                        fillMode={'outline'}
                        className="button-small"
                        disabled={isLastPage}
                        onClick={() => setPage(page + 1)}
                    />
                    <Button
                        svgIcon={DoubleChevronRightOutline}
                        fillMode={'outline'}
                        className="button-small"
                        disabled={isLastPage}
                        onClick={() => setPage(maxPage - 1)}
                    />
                </div>
            )}
            <table className="cobalt-table cobalt-alternate w-100">
                <thead>
                    <tr style={{ backgroundColor: 'var(--alternate-color)' }}>
                        <th className="ps-2">Latitude</th>
                        <th>Longitude</th>
                        <th style={{ width: 70 }}></th>
                    </tr>
                </thead>
                <tbody>
                    {props.points.slice(SIZE * page, Math.min(SIZE * page + SIZE, props.points.length - 1)).map((x, i) => {
                        return (
                            <tr key={x.id}>
                                <DrawingObjectEditPoint
                                    disabled={props.disabled}
                                    deleteDisabled={props.points.length < 5}
                                    lngLat={x.lngLat}
                                    index={i}
                                    onDelete={props.onPointDelete}
                                    onChange={props.onPointChange}
                                />
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default DrawingObjectPolygonPoints;
